import { cloneDeep } from 'lodash';
import Backbone from 'backbone-model';

import Chat from 'entities/Chat';
import ChatMember from 'entities/ChatMember';
import Entity from 'lib/Entity';

// @ts-ignore
import { PotentialOrRegularChatMember } from 'entities/PotentialChatMember'; // eslint-disable-line

class ChatMembership extends Entity {
  parse(response: any) {
    const membership = cloneDeep(response);
    membership['user'] = ChatMember.fromJSON(membership['user']);
    if (membership['left_at']) {
      membership['left_at'] = new Date(membership['left_at']);
    }
    if (membership['unsubscribed_at']) {
      membership['unsubscribed_at'] = new Date(membership['unsubscribed_at']);
    }
    return membership;
  }

  defaults() {
    return {
      state: 'present',
    };
  }

  getMember(): ChatMember {
    return this.get('user');
  }

  setMember(member: ChatMember): Backbone.Model {
    return this.set({ user: member });
  }

  canRemove(): boolean {
    return !!this.get('can_remove');
  }

  getState() {
    return this.get('state');
  }

  isPresent(): boolean {
    return this.getState() === 'present';
  }

  isCreator(chat: Chat): boolean {
    return chat.getCreatorId() === this.getMember().id;
  }

  hasLeft(): boolean {
    return this.getState() === 'left';
  }

  hasBeenRemoved(): boolean {
    return this.getState() === 'removed';
  }

  leaveChat() {
    return this.set({ state: 'left', left_at: new Date() });
  }

  getLeftAt() {
    return this.get('left_at');
  }

  getUnsubscribedAt() {
    return this.get('unsubscribed_at');
  }

  static create(member: PotentialOrRegularChatMember) {
    return new ChatMembership({
      user: new ChatMember(member.attributes),
    });
  }
}

export default ChatMembership;
